import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from '../../environments/environment';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AppInsightsService {
  instance: ApplicationInsights;

  constructor(private router: Router) {
    this.instance = new ApplicationInsights({
      config: {
        instrumentationKey: environment.appInsights.instrumentationKey,
        enableCorsCorrelation: true,
        enableAutoRouteTracking: true,
        correlationHeaderExcludedDomains: environment.appInsights.correlationHeaderExcludedDomains,
      },
    });

    if (environment.appInsights.logErrors) {
      this.startAppInsights();
    }
  }

  logPageView(name?: string, url?: string) {
    // option to call manually
    this.instance.trackPageView({
      name: name,
      uri: url,
    });
  }

  logEvent(name: string, properties?: { [key: string]: any }) {
    this.instance.trackEvent({ name: name }, properties);
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    this.instance.trackMetric({ name: name, average: average }, properties);
  }

  logException(exception: Error, severityLevel?: number) {
    this.instance.trackException({
      exception: exception,
      severityLevel: severityLevel,
    });
  }

  logTrace(message: string, properties?: { [key: string]: any }) {
    this.instance.trackTrace({ message: message }, properties);
  }

  private loadCustomTelemetryProperties() {
    this.instance.addTelemetryInitializer((envelope) => {
      const item = envelope.baseData;
      item.properties = item.properties || {};
      item.properties['ApplicationPlatform'] = 'WEB';
      item.properties['ApplicationName'] = 'INNOVATROVE.SPA';
    });
  }

  private createRouterSubscription() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.logPageView(null, event.urlAfterRedirects);
    });
  }

  private startAppInsights(): void {
    this.instance.loadAppInsights();
    this.instance.trackPageView();
    this.loadCustomTelemetryProperties();
    this.createRouterSubscription();
  }
}
